import ApiService from './api.service';
import logger from '@/utils/logger';

class CheckFieldAdjustmentService {
    // Get field adjustments for a company
    static async getFieldAdjustments(companyId, templateName = 'default') {
        try {
            const response = await ApiService.get(`/vendor/${companyId}/field-adjustments?templateName=${templateName}`);
            return response.data;
        } catch (error) {
            logger.error('Error getting field adjustments:', error);
            throw error;
        }
    }

    // Save field adjustments for a company
    static async saveFieldAdjustments(companyId, fieldAdjustments, templateName = 'default', description = null) {
        try {
            const response = await ApiService.post(`/vendor/${companyId}/field-adjustments`, {
                templateName,
                fieldAdjustments,
                description
            });
            return response.data;
        } catch (error) {
            logger.error('Error saving field adjustments:', error);
            throw error;
        }
    }

    // Get all templates for a company
    static async getTemplates(companyId) {
        try {
            const response = await ApiService.get(`/vendor/${companyId}/templates`);
            return response.data;
        } catch (error) {
            logger.error('Error getting templates:', error);
            throw error;
        }
    }

    // Delete a template
    static async deleteTemplate(companyId, templateId) {
        try {
            const response = await ApiService.delete(`/vendor/${companyId}/templates/${templateId}`);
            return response.data;
        } catch (error) {
            logger.error('Error deleting template:', error);
            throw error;
        }
    }

    // Convert frontend fieldAdjustments to API format
    static convertToApiFormat(fieldAdjustments) {
        return {
            date: {
                fontSize: fieldAdjustments.date.fontSize,
                width: fieldAdjustments.date.width,
                height: fieldAdjustments.date.height,
                x: fieldAdjustments.date.x,
                y: fieldAdjustments.date.y
            },
            amount: {
                fontSize: fieldAdjustments.amount.fontSize,
                width: fieldAdjustments.amount.width,
                height: fieldAdjustments.amount.height,
                x: fieldAdjustments.amount.x,
                y: fieldAdjustments.amount.y
            },
            payee: {
                fontSize: fieldAdjustments.payee.fontSize,
                width: fieldAdjustments.payee.width,
                height: fieldAdjustments.payee.height,
                x: fieldAdjustments.payee.x,
                y: fieldAdjustments.payee.y
            },
            memo: {
                fontSize: fieldAdjustments.memo.fontSize,
                width: fieldAdjustments.memo.width,
                height: fieldAdjustments.memo.height,
                x: fieldAdjustments.memo.x,
                y: fieldAdjustments.memo.y
            },
            amountInWords: {
                fontSize: fieldAdjustments.amountInWords.fontSize,
                width: fieldAdjustments.amountInWords.width,
                height: fieldAdjustments.amountInWords.height,
                x: fieldAdjustments.amountInWords.x,
                y: fieldAdjustments.amountInWords.y
            }
        };
    }

    // Get default field adjustments
    static getDefaultFieldAdjustments() {
        return {
            date: { fontSize: 12, width: 120, height: 18, x: 450, y: 30 },
            amount: { fontSize: 14, width: 120, height: 22, x: 460, y: 95 },
            payee: { fontSize: 14, width: 350, height: 22, x: 99, y: 97 },
            memo: { fontSize: 12, width: 250, height: 18, x: 70, y: 191 },
            amountInWords: { fontSize: 12, width: 450, height: 18, x: 108, y: 150 }
        };
    }
}

export default CheckFieldAdjustmentService;
